/*
* 17/11/29
* This component probably doesn't need to be a component
* It was created to fix a bug coming from iOS11 :
* When inputs/forms are placed within a fixed positioned container,
* when focusing on an input, the input caret is totally misplaced
* because it is being pushed by the soft keyboard from iOS.
 */

import Component from '../colorz/Component';
import device from '../colorz/utils/device';
import emitter from '../colorz/utils/Emitter';


module.exports = class PopinInputs extends Component{
    onInit( el ) {
        this.onPopinClose = this.onPopinClose.bind( this );
        this.onPopinOpen  = this.onPopinOpen.bind( this );

        this.el     = el;
        this.id     = this.el.id;
        this.bodyChildren = document.querySelector('body').childNodes;
    }

    onReady() {
        // déclaration des events émis dans PopinManager
        emitter.on('popin:close', this.onPopinClose);
        emitter.on('popin:open', this.onPopinOpen);
    }

    onPopinClose( id ) {
        if( this.id != id ) { return; }

        for (let i = 0; i < this.bodyChildren.length; i++) {
            if (this.bodyChildren[i].nodeName == 'DIV'
                || this.bodyChildren[i].nodeName == 'HEADER'
                || this.bodyChildren[i].nodeName == 'FOOTER') {
                this.bodyChildren[i].classList.remove('hidden');
            }
        }
    }

    onPopinOpen( id ) {
        if( this.id != id ) { return; }

        for (let i = 0; i < this.bodyChildren.length; i++) {
            if (
                this.bodyChildren[i].nodeName == 'DIV' ||
                this.bodyChildren[i].nodeName == 'HEADER' ||
                this.bodyChildren[i].nodeName == 'FOOTER'
                ) {
                if ( device.width < 768 ) {
                    this.bodyChildren[i].classList.add('hidden');
                }
            }
        }

        this.el.classList.remove('hidden');
    }
}